export default __webpack_public_path__ + "static/media/largeTable.81a2f8d4.svg";